/**
 * 日期转农历称呼速查表
 * @Array Of Property
 * @trans ['初','十','廿','卅']
 * @return Cn string
 */
export default ['\u521d', '\u5341', '\u5eff', '\u5345'];
